import React from 'react'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { ProjectDiscountPayload } from 'src/core/models'

const ProjectDiscountAmountTypeColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {
  const { t } = useTranslation()

  const label = {
    'PERCENTAGE': t('Discount.Percentage'),
    'FLAT_AMOUNT': t('Discount.FlatAmount')
  }[discount.amount_type]

  return <CustomText label={label} />
}

export default ProjectDiscountAmountTypeColumn
